import { render } from "./ChatReplyDialog.vue?vue&type=template&id=2bd9ca70"
import script from "./ChatReplyDialog.vue?vue&type=script&lang=js"
export * from "./ChatReplyDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bp-kmiyajima\\Documents\\Projects\\noritz-protal\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__